import { cn } from '../cn';

/** Пустое значение — бледное «…», никогда не прочерк «—»; один светло-серый цвет во всём разделе. */
export function EmptyValue({ className }: { className?: string }) {
  return <span className={cn('nd:font-normal nd:text-foreground/30', className)}>…</span>;
}
